const PREFIX = 'wfmed_onboarding'

function keyFor(tourId, userId) {
  return `${PREFIX}:${userId || 'local'}:${tourId}`
}

export function isOnboardingDone(tourId, userId) {
  try {
    return localStorage.getItem(keyFor(tourId, userId)) === 'done'
  } catch {
    return true
  }
}

export function completeOnboarding(tourId, userId) {
  try {
    localStorage.setItem(keyFor(tourId, userId), 'done')
  } catch {
    // Sem armazenamento o tour só deixa de aparecer nesta visita.
  }
}
